import { render, staticRenderFns } from "./paper.vue?vue&type=template&id=c08e6932&scoped=true&"
var script = {}
import style0 from "./paper.vue?vue&type=style&index=0&id=c08e6932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08e6932",
  null
  
)

export default component.exports